// LICENSE_CODE ZON
'use strict'; /*jslint ts:true, react:true*/
import React, {useContext, useState} from 'react';
import cn from 'classnames';
import {Settings_context} from '../settings_ctx';
import styles from './products.module.less';
import Icon_chevron_down from '../img/svg/icon/chevron_down.svg';

interface I_faq_quest_props {
  quest: string;
  ans: JSX.Element;
  cls?: {
    title?: string,
    text?: string
  };
  scrollable?: boolean;
}
export const Faq_question = (props: I_faq_quest_props)=>{
    const {theme} = useContext(Settings_context);
    const [opened, set_opened] = useState(false);
    return <div className={cn(styles.faq_item, opened && styles.opened,
      props.cls && props.cls.title)}>
      <div className={cn(styles.title_line, props.scrollable &&
        styles.title_padding)} onClick={()=>{
        set_opened(!opened);
      }}>
        <p className={cn(theme.p3, theme.med)}>{props.quest}</p>
        <Icon_chevron_down/>
      </div>
      <div className={cn(styles.faq_text, props.cls && props.cls.text,
        props.scrollable && styles.scroll)}>
        <div className={cn(theme.p3, theme.med)}>{props.ans}</div>
      </div>
    </div>;
};
